import script from "./MSBookingsFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./MSBookingsFrame.vue?vue&type=script&setup=true&lang=ts"

import "./MSBookingsFrame.vue?vue&type=style&index=0&id=f1784850&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1784850"]])

export default __exports__